import React, { useEffect, useState } from "react";
import { RadialBarChart, RadialBar, PolarAngleAxis, ResponsiveContainer } from "recharts";
interface SalesPerformanceMeterProps {
  achievement: number;
  target: number;
}
const SalesPerformanceMeter: React.FC<SalesPerformanceMeterProps> = ({
  achievement,
  target
}) => {
  const [percentage, setPercentage] = useState(0);
  const achievementPercent = Math.min(achievement / target * 100, 100);
  useEffect(() => {
    const timer = setTimeout(() => {
      setPercentage(achievementPercent);
    }, 100);
    return () => clearTimeout(timer);
  }, [achievement, target, achievementPercent]);
  const getColor = (percent: number) => {
    if (percent < 50) return "#FF4C4C"; // Red
    if (percent < 100) return "#FFD700"; // Yellow
    return "#00C853"; // Green
  };
  const data = [{
    value: percentage,
    fill: getColor(percentage)
  }];
  const formatCurrency = (value: number): string => {
    return value.toLocaleString('en-US', {
      style: 'currency',
      currency: 'USD',
      minimumFractionDigits: 0,
      maximumFractionDigits: 0
    });
  };

  // Calculate needle angle
  // 0% achievement = 180 degrees (left side of arc)
  // 100% achievement = 0 degrees (right side of arc)
  //const needleAngle = 180 - (percentage * 180 / 100);
  const needleAngle = percentage * 1.8 - 96;
  return <div className="flex flex-col items-center justify-center w-full relative">
      <ResponsiveContainer width="100%" height={250}>
        <RadialBarChart cx="50%" cy="50%" innerRadius="60%" outerRadius="95%" barSize={18} data={data} startAngle={180} endAngle={0}>
          <PolarAngleAxis type="number" domain={[0, 100]} angleAxisId={0} tick={false} axisLineType="circle" />
          <RadialBar background={{
          fill: "#444"
        }} dataKey="value" cornerRadius={10} startAngle={0} endAngle={180} />
        </RadialBarChart>
      </ResponsiveContainer>
      
      <div className="absolute h-[110px] w-[3px] bg-red-500 origin-bottom" style={{
      top: '25px',
      left: '50%',
      transform: `translateX(-50%) rotate(${needleAngle}deg)`,
      transformOrigin: 'bottom',
      transition: 'transform 0.5s ease-out'
    }}>
        <div className="absolute w-[12px] h-[12px] rounded-full bg-red-500" style={{
        top: '-6px',
        left: '-4.5px'
      }} />
      </div>
      
      <div className="absolute flex items-center justify-center text-white font-bold text-lg" style={{
      top: '10px',
      left: '50%',
      transform: `translateX(-50%) rotate(${needleAngle}deg) translateY(-25px) rotate(${-needleAngle}deg)`,
      transformOrigin: 'center',
      transition: 'transform 0.5s ease-out',
      color: getColor(percentage)
    }}>
        {percentage.toFixed(2)}%
      </div>
      
      <div className="absolute flex flex-col items-bottom justify-bottom inset-0 mt-12 mx-0 my-[64px] py-[81px] px-[37px]">
        <div className="flex justify-between w-full mt-1 text-large px-[90px]">
          <div className="text-purple-400 my-0">{formatCurrency(achievement)}</div>
          <div className="text-blue-400">{formatCurrency(target)}</div>
        </div>
        <div className="flex justify-between w-full text-large text-gray-400 px-[106px]">
          <span className="text-primary-light">Achieved</span>
          <span className="text-indigo-300">Target</span>
        </div>
      </div>
    </div>;
};
export default SalesPerformanceMeter;